import { Modal, Button } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';

export const ConfirmationModal = ({
  isOpen,
  onDelete,
  onCancel,
}: {
  isOpen: boolean;
  onDelete: () => void;
  onCancel: () => void;
}): JSX.Element => {
  const { t } = useTranslationWithPrefix('mfa:trusted-devices.modal');

  return (
    <Modal isOpen={isOpen} contentLabel={t('title')} size="s">
      <Modal.Header title={t('title')} />
      <Modal.Body>{t('description')}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onCancel}>
          {t('cancel')}
        </Button>
        <Button kind="danger" onClick={onDelete}>
          {t('remove')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
